<template>
  <v-footer id="footer" style="background-color: black; color: white; font-size: small;">
    <v-row justify="center" cols="10" no-gutters>
      <v-col cols="10" md="3" class="pa-2 ma-2">
        <v-img src="@/assets/syxpay/syxpay_logo_about.png" width="130px" />
        <h3 class="py-4">
          PT. Systemagix Syxpay Indonesia
        </h3>
        <p>
          BINTARO BUSINESS CENTER <br>
          JALAN RC VETERAN NOMOR RAYA 1I <br>
          Kel. Bintaro, Kec. Pesanggrahan<br>
          Kota Adm. Jakarta Selatan, Provinsi DKI Jakarta<br>
          Kode Pos: 12330
        </p>
        <p>
          © 2024 Systemagix Syxpay Indonesia
        </p>
      </v-col>
      <v-col cols="10" md="7" class="pa-2 ma-2">
        <v-row no-gutters>
          <v-col>
            <h2 class="pb-3">
              Company
            </h2>
            <button class="cursor-pointer" @click="$vuetify.goTo('#about')">About</button>
          </v-col>
          <v-col>
            <h2 class="pb-3">
              Product
            </h2>
            <p>
              <button @click="$vuetify.goTo('#products')">PPOB</button>
            </p>
            <p>
              <button @click="$vuetify.goTo('#products')">My Bizz</button>
            </p>
            <p>
              <button @click="$vuetify.goTo('#products')">Transfer Terjadwal</button>
            </p>
            <p>
              <button @click="$vuetify.goTo('#products')">Financial Planner</button>
            </p>
            <p>
              <button @click="$vuetify.goTo('#products')">E-Education</button>
            </p>
          </v-col>
          <v-col>
            <h2 class="pb-3">
              Support
            </h2>
            <p>
              <button @click="$vuetify.goTo('#')">Terms & Conditions</button>
            </p>
            <p>
              <button @click="$vuetify.goTo('#')">Privacy Policy</button>
            </p>
          </v-col>
          <v-col>
            <h2 class="pb-3">
              Contact Us
            </h2>
            <p>
              <button @click="$vuetify.goTo('#')">Help Center</button>
            </p>
          </v-col>
          <v-col>
            <h2 class="pb-3">
              Download The App
            </h2>
            <v-row>
              <v-col><v-img width="30px" src="@/assets/syxpay/google_store.png"></v-img></v-col>
              <v-col><v-img width="30px" src="@/assets/syxpay/app_store.png"></v-img></v-col>
              <v-col></v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  data: () => ({}),
};
</script>
